import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { BulkGrantDetailDownloadResponse } from '@/repositories/generated';

const response: BulkGrantDetailDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['ユーザID', '外部ユーザID', '決済手段ID', '付与口座', '付与数', '有効期限', 'ステータス'],
    ['1', '1', '1', '1', '1', '2023-01-01', 'SCHEDULED'],
  ]),
};

export const bulkGrantDetailDownload = http.get(
  createMockEndpoint('/bulk_grant/:id/download/detail'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
